import type { AlgorithmMappingValidFormDataType } from './types';

export const defaultMappingFormData: AlgorithmMappingValidFormDataType = {
  classifierMapping: null!,
  sourceDimension: null!,
  alias: '',
  joinTypeCode: 'LEFT_OUTER',
};
